import React from "react";
import { Spinner, Table, Input } from "reactstrap";
import "../components/style/table.scss";
import NoDataIndication from "../components/NoDataIndication";
import moment from "moment";

function TablewithPagination(props) {
	const {
		IsLoaded,
		sortBy,
		tableHeader,
		spMontlyTimesheet,
		defaultSorted,
		adminCalendarHolidaysData,
	} = props;

	return (
		<div className="table-responsive">
			<Table borderless className="table monthlyTimesheetTable">
				<thead className="tableHead">
					<tr>
						{/** ------------------------------tableHeader-----------------------------*/}
						{tableHeader.map((item, index) => {
							const { displayName, name, sort } = item;
							if (name === "checkbox")
								return (
									<>
										<th key={index}>
											<Input
												className="ml-2 checkboxInput"
												type="checkbox"
												onChange={(event) => {
													props.onHeaderCheckboxChange(
														event.target.checked
													);
												}}
											/>
										</th>
									</>
								);
							else
								return (
									<>
										{sort ? (
											<th
												key={index}
												className="sort"
												colSpan={
													name === "supComments"
														? 8
														: 0
												}
												onClick={() => sortBy(name)}
											>
												{displayName}
												{defaultSorted.dataField ===
												name ? (
													defaultSorted.order ===
													"asc" ? (
														<span className="caret-ascSorted-symbol" />
													) : (
														<span className="caret-descSorted-symbol" />
													)
												) : (
													<span className="caret-nonSorted-symbol" />
												)}
											</th>
										) : (
											<th
												key={index}
												colSpan={
													name === "supComments"
														? 8
														: 0
												}
											>
												{displayName}{" "}
											</th>
										)}
									</>
								);
						})}
					</tr>
				</thead>

				{/** ------------------------------Supervisor Montly Timesheet-----------------------------*/}
				<tbody className="tableBody">
					{spMontlyTimesheet ? (
						IsLoaded ? (
							spMontlyTimesheet.length === 0 ? (
								<tr>
									<td
										data-toggle="collapse"
										colSpan="20"
										className="noRecordContainer"
									>
										<div
											className="font-weight-bold mt-4"
											bis_skin_checked="1"
										>
											<span className="noRecord">
												NO RECORD FOUND
											</span>
										</div>
									</td>
								</tr>
							) : (
								spMontlyTimesheet.map((data, index) => {
									return (
										<tr
											key={index}
											className={
												index % 2 === 0
													? "rowStyle1"
													: "rowStyle2"
											}
										>
											<td>
												<Input
													className="ml-2 checkboxInput"
													type="checkbox"
													checked={props.selectedRows?.includes(
														index
													)}
													onChange={() => {
														props.onCheckboxChange(
															index
														);
													}}
												/>
											</td>
											<td>{data.empName}</td>
											<td>{data.recordMonth}</td>
											<td>{data.calculatedDays}</td>
											<td>
												{data.hoursWorked.slice(
													0,
													data.hoursWorked.lastIndexOf(
														":"
													)
												)}
											</td>
											<td>
												{data.hoursExpected.slice(
													0,
													data.hoursExpected.lastIndexOf(
														":"
													)
												)}
											</td>
											<td>{data.noOfLateComings}</td>
											<td>
												{data.hoursDifferenceValues}
											</td>
											<td>
												{data.systemCalculatedDeduction}
											</td>
											{props.empId === "33" ? ( //admin
												<>
													<td>
														{
															data.supSuggestedDeduction
														}
													</td>
													<td colSpan={8}>
														{data.supComments}
													</td>
												</>
											) : //Not admin
											props.selectedRows?.includes(
													index
											  ) &&
											  data.adminStatus === "Pending" ? (
												<>
													<td>
														<div className="d-flex align-items-center">
															<Input
																type="text"
																value={
																	props
																		.supSuggestedDeduction[
																		index
																	]
																}
																id="supSuggestedDeduction"
																onChange={(
																	event
																) =>
																	props.onSupSuggestedChange(
																		event
																			.target
																			.value,
																		index
																	)
																}
																className={`${
																	props.errorInRows?.includes(
																		index
																	)
																		? "h-auto invalid"
																		: "h-auto"
																}`}
															/>
														</div>
													</td>
													<td colSpan={8}>
														{" "}
														<Input
															type="text"
															value={
																data.supComments
															}
															onChange={(event) =>
																props.onSupCommentsChange(
																	data.sheetId,
																	event.target
																		.value
																)
															}
														/>{" "}
													</td>
												</>
											) : (
												<>
													<td>
														{
															data.supSuggestedDeduction
														}
													</td>
													<td colSpan={8}>
														{data.supComments}
													</td>
												</>
											)}
											<td>{data.supStatus}</td>
											{props.empId === "33" &&
											data.adminStatus != "Processed" &&
											props.selectedRows?.includes(
												index
											) ? ( //admin
												<td>
													{" "}
													<div className="d-flex align-items-center">
														<Input
															type="text"
															value={
																props
																	.supSuggestedDeduction[
																	index
																]
															}
															id="supSuggestedDeduction"
															onChange={(event) =>
																props.onSupSuggestedChange(
																	event.target
																		.value,
																	index
																)
															}
															className={`${
																props.errorInRows?.includes(
																	index
																)
																	? "h-auto invalid"
																	: "h-auto"
															}`}
														/>
													</div>
												</td>
											) : (
												<td>{data.adminApproved}</td>
											)}
											<td>{data.adminStatus}</td>
										</tr>
									);
								})
							)
						) : (
							<tr>
								<td colSpan="20" className="mt-3">
									<Spinner color="secondary" />
								</td>
							</tr>
						)
					) : null}

					{/** ------------------------------Admin Role-----------------------------*/}
					{adminCalendarHolidaysData ? (
						IsLoaded ? (
							adminCalendarHolidaysData.length == 0 ? (
								<NoDataIndication />
							) : (
								adminCalendarHolidaysData.map((data, index) => {
									return (
										<tr
											key={index}
											className={
												index % 2 === 0
													? "rowStyle1"
													: "rowStyle2"
											}
										>
											<td className="col-lg-2">
												{moment(data.startDate).format(
													"DD/MM/YYYY"
												)}
											</td>
											<td className="col-lg-2">
												{moment(data.endDate).format(
													"DD/MM/YYYY"
												)}
											</td>
											<td className="col-lg-1">
												{data.duration}
											</td>
											<td className="description col-lg-7">
												{data.description}
											</td>
										</tr>
									);
								})
							)
						) : (
							<tr>
								<td colspan="7" className="pt-4">
									<Spinner color="secondary" />
								</td>
							</tr>
						)
					) : null}
				</tbody>
			</Table>
		</div>
	);
}

export default TablewithPagination;
